module.exports = __webpack_public_path__ + "img/s2-2-s.11a2ec04.svg";